<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import IconError from '~icons/material-symbols/error-outline'

interface Props {
  id: string
}

defineProps<Props>()

const emit = defineEmits<{
  retry: []
}>()

const { t } = useI18n()
</script>

<template>
  <div :id="id" class="block-error" role="alert">
    <IconError class="block-error-icon" aria-hidden="true" />
    <p class="block-error-text">
      {{ t('my_wallet.block_error.title') }}
    </p>
    <button
      :id="`${id}-retry`"
      type="button"
      class="block-error-retry"
      @click="emit('retry')"
    >
      {{ t('my_wallet.block_error.retry') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.block-error {
  @apply flex flex-wrap items-center gap-2 w-full p-4 rounded-md;
  @apply bg-neutral-high-light border border-neutral-high-medium;

  .block-error-icon {
    @apply w-5 h-5 flex-shrink-0 text-feedback-negative-pure;
  }

  .block-error-text {
    @apply flex-1 fonts-body-medium-regular text-neutral-low-dark;
  }

  .block-error-retry {
    @apply fonts-body-medium-bold text-neutral-low-dark underline cursor-pointer;
  }
}
</style>
